import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/input/text';
import { createAlert } from '@src/actions/BotActions';

import styles from './NumericRangeEntityConfig.scss';

export default class NumericRangeEntityConfig extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.left}>
          <Text
            disabled={this.props.disabled}
            label="Minimum number of Digits"
            placeholder="Minimum number of digits that should be detected by this entity"
            value={this.props.metaData.minNumberDigits}
            onChange={this._onMinNumberChange}
            inputType="number"
            min={1}
          />
          <Text
            disabled={this.props.disabled}
            label="Maximum number of Digits"
            placeholder="Maximum number of digits that should be detected by this entity"
            value={this.props.metaData.maxNumberDigits}
            onChange={this._onMaxNumberChange}
            inputType="number"
            min={1}
          />
        </div>
        <div className={styles.right} />
      </div>
    );
  }

  _onMinNumberChange = value => {
    const metaData = this.props.metaData;
    metaData.minNumberDigits = value;
    this.props.onChange(metaData);
  };

  _onMaxNumberChange = value => {
    const metaData = this.props.metaData;
    metaData.maxNumberDigits = value;
    this.props.onChange(metaData);
  };

  validate = () => {
    if (
      this.props.metaData.minNumberDigits === undefined ||
      this.props.metaData.maxNumberDigits === undefined
    ) {
      createAlert('Please specify min/max number of digits');
      return false;
    }

    const min = parseInt(this.props.metaData.minNumberDigits, 10);
    const max = parseInt(this.props.metaData.maxNumberDigits, 10);

    if (min > max) {
      createAlert(
        'Min number of digits cannot be more than Max number of digits'
      );
      return false;
    }
    return true;
  };
}

NumericRangeEntityConfig.propTypes = {
  metaData: PropTypes.shape({
    minNumberDigits: PropTypes.string,
    maxNumberDigits: PropTypes.string,
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
